import { ApiBaseUrls } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

/**
 * Sends a POST request to refresh coverage data for a medical PA order.
 *
 * @param orderId - The order ID to refresh coverage for
 * @param onSuccess - Optional callback invoked with the response on success
 * @param onError - Optional callback invoked with the error on failure
 * @returns The fetch Response on success
 * @throws Re-throws the error after logging and invoking onError
 */
export async function postRequestForCoverageRefresh(
  orderId: string,
  onSuccess?: (response: Response) => void,
  onError?: (error: Error) => void,
) {
  const url = `${ApiBaseUrls.COVERAGE_SERVICE}coverage/check-coverage-for-medical-pa-order`;
  const requestBody = { order_id: orderId };

  try {
    const bearerToken = await getBearerToken();
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${bearerToken}`,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Request failed with status ${response.status}: ${errorText}`,
      );
    }
    onSuccess?.(response);
    return response;
  } catch (error) {
    logError(error as Error, "Error while refreshing coverage");
    onError?.(error as Error);
    throw error;
  }
}
